module.exports = __webpack_public_path__ + "static/media/paratomar.2453fbda.svg";